import angular from 'angular';

import { ExpandableSectionComponent } from './expandable-section.component';

angular
  .module('core.components.expandable-section', [])
  .component('easyshipExpandableSection', ExpandableSectionComponent);
